import { SettingsEndpoint } from '@constants/ApiEndpoints';
import { AxiosInstance } from 'axios';
import { QuickMenuRequestModel } from '../../../models/Settings/ApplicationSettings/QuickMenuModel';

export const create =
  (axios: AxiosInstance) =>
  async (data: QuickMenuRequestModel[]): Promise<QuickMenuRequestModel[]> => {
    return await axios
      .post(SettingsEndpoint.SETTINGS_APPLICATION_QUICK_MENU, {
        ...data[0],
      })
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: QuickMenuRequestModel[]): Promise<QuickMenuRequestModel[]> => {
    return await axios
      .put(SettingsEndpoint.SETTINGS_APPLICATION_QUICK_MENU, {
        quick_menu: data,
      })
      .then(({ data }) => data);
  };

export const remove =
  (axios: AxiosInstance) =>
  async (targets: string[]): Promise<QuickMenuRequestModel[]> => {
    return await axios
      .delete(SettingsEndpoint.SETTINGS_APPLICATION_QUICK_MENU, {
        data: {
          targets,
        },
      })
      .then(({ data }) => data);
  };
